export const LOGIN_USER = 'login_user';
export const AUTH_USER = 'auth_user';
export const LOGOUT_USER = 'logout_user';
export const VERIFY_MFA = 'verify_mfa';
